import RoundedGradientBorderBox from '../RoundedGradientBorderBox';
import Text from '../Text/Text';
import { Points } from '@drift-labs/icons';
import { twMerge } from 'tailwind-merge';
import useDriftTheme from 'src/hooks/useDriftTheme';
import { DriftTheme } from 'src/environmentVariables/EnvironmentVariableTypes';
import useNavigationState from '../Navigation/useNavigationState';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { usePointsStore } from 'src/stores/usePointsStore';
import { printPoints } from 'src/utils/points';

function DriftPointsChip() {
	const theme = useDriftTheme();
	const { navigateToRoute } = useNavigationState();
	const isMobile = useIsMobileScreenSize();
	const authorityPoints = usePointsStore((s) => s.authorityScore);

	const isDarkTheme = theme === DriftTheme.dark;
	const points = authorityPoints ?? 0;

	const handleRouteToPointsPage = () => {
		navigateToRoute('points');
	};

	return (
		<RoundedGradientBorderBox
			borderColour="var(--drift-points-gradient)"
			borderHoverClass="var(--drift-points-gradient)"
			className="h-full cursor-pointer"
			borderRadius="4px"
		>
			<div
				onClick={handleRouteToPointsPage}
				className={twMerge(
					'flex items-center h-full gap-1 px-2',
					isDarkTheme ? 'bg-main-bg' : 'bg-[var(--drift-points-gradient)]'
				)}
			>
				{!isMobile && (
					<Points
						size={24}
						className={twMerge(
							'-ml-1',
							isDarkTheme ? 'points-icon-dark-theme' : 'points-icon-light-theme'
						)}
					/>
				)}
				<Text.BODY1
					className={twMerge(
						'font-bold uppercase whitespace-nowrap',
						isDarkTheme ? ' drift-points-text-gradient' : 'text-white'
					)}
				>
					{!points || isMobile ? '' : printPoints(points)} Point
					{Math.floor(points) <= 1 ? '' : 's'}
				</Text.BODY1>
			</div>
		</RoundedGradientBorderBox>
	);
}

export default DriftPointsChip;
